import CustomViewOptionCustomSection from "csi/middleware/customView/options/CustomViewOptionCustomSection";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import SecondaryDisplayCustomViewOptionsStore from "src/Merchandising/SecondaryDisplay/SecondaryDisplayCustomViewOptionsStore";
import { useCustomViewDialogStore } from "../../csi/middleware/customView/CustomViewDialogStore";
import SecondaryDisplayOptions from "./SecondaryDisplayOptions";

const SecondaryDisplayViewOptions: FunctionComponent = observer(function SecondaryDisplayViewOptions() {
	const { optionsStore } = useCustomViewDialogStore();

	const {
		toggleCollapsedViewSpecificOptions,
		viewSpecificOptionsCollapse,
	} = optionsStore as SecondaryDisplayCustomViewOptionsStore;

	return (
		<CustomViewOptionCustomSection
			collapsed={viewSpecificOptionsCollapse}
			onCollapse={toggleCollapsedViewSpecificOptions}
			titleRes="CustomViewSecondaryDisplayOptions"
		>
			<SecondaryDisplayOptions />
		</CustomViewOptionCustomSection>
	);
});

export default SecondaryDisplayViewOptions;